import { wrapCreateBrowserRouterV6 } from "@sentry/react";
import { createBrowserRouter } from "react-router-dom";

export const sentryCreateBrowserRouter = wrapCreateBrowserRouterV6(createBrowserRouter);
